import { render, staticRenderFns } from "./SkillTableDesktop.vue?vue&type=template&id=141759d2&scoped=true&"
var script = {}
import style0 from "./SkillTableDesktop.vue?vue&type=style&index=0&id=141759d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141759d2",
  null
  
)

export default component.exports